import React, {
  PropsWithChildren,
  FunctionComponent,
  CSSProperties,
} from 'react';
import { DATA_HOOKS } from '../constants';

type SlideProps = PropsWithChildren & {
  dataHook?: string;
  className?: string;
  image?: {
    src: string;
  };
  width?: string;
  gutter?: string;
  imagePosition?: string;
  imageFit?: CSSProperties['objectFit'];
  isVisible?: boolean;
};

const Slide: FunctionComponent<SlideProps> = ({
  dataHook,
  className,
  children,
  image,
  width,
  gutter,
  imagePosition,
  imageFit,
  isVisible = true,
}) => (
  <div
    data-hook={dataHook}
    className={className}
    role="listitem"
    style={{
      flex: '0 0 auto',
      width,
      marginInlineStart: gutter,
      objectPosition: imagePosition,
      objectFit: imageFit,
    }}
    tabIndex={!isVisible ? -1 : undefined}
    aria-hidden={!isVisible}
  >
    {image ? (
      <img data-hook={DATA_HOOKS.carouselImage} src={image.src} />
    ) : (
      children
    )}
  </div>
);

export default Slide;
